import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export type UpdateTopicDto = {
  title: string;
};

export const updateTopic = async (topicId: string, params: UpdateTopicDto) => {
  const [response, bodyOrError] = await Api.patch(`topics/${topicId}`, params);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useUpdateTopic = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'updateTopic',
    (data: { topicId: string; params: UpdateTopicDto }) => {
      return updateTopic(data.topicId, data.params);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['topics']);
        queryClient.invalidateQueries(['getTopic']);
      },
    },
  );
};
